import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { bookingCheckoutSettingsService } from "@/services/booking-checkout-settings.service";

export const useCheckoutServiceLists = (hotelId: string) => {
    const queryClient = useQueryClient();

    const checkoutRecommended = useQuery({
        queryKey: ["checkoutRecommendedServices", hotelId],
        queryFn: () => bookingCheckoutSettingsService.getCheckoutRecommendedServices(hotelId),
        enabled: !!hotelId,
    });

    const finalUpsell = useQuery({
        queryKey: ["finalCheckoutUpsellServices", hotelId],
        queryFn: () => bookingCheckoutSettingsService.getFinalCheckoutUpsellServices(hotelId),
        enabled: !!hotelId,
    });

    const updateCheckoutRecommended = useMutation({
        mutationFn: (serviceIds: string[]) =>
            bookingCheckoutSettingsService.updateCheckoutRecommendedServices(hotelId, serviceIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["checkoutRecommendedServices", hotelId] });
        },
    });

    const updateFinalUpsell = useMutation({
        mutationFn: (serviceIds: string[]) =>
            bookingCheckoutSettingsService.updateFinalCheckoutUpsellServices(hotelId, serviceIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["finalCheckoutUpsellServices", hotelId] });
        },
    });

    return {
        checkoutRecommended,
        finalUpsell,
        updateCheckoutRecommended,
        updateFinalUpsell,
    };
};
